export const confirmationModalOfClusterValueChain = {
    checkBoxLabel: '今後は表示しない',
    cancel: 'キャンセル',
    changeCrossVCMode:
        'IBA分析をバリューチェーンごとではなく、バリューチェーンを横断して実施した結果のデータに変更します。\n' +
        'バリューチェーンが異なる企業であっても同一技術であれば、同一のクラスタにおいて技術スコア等を比較する際に有効なモードです。\n' +
        '分析軸が異なるため、データが再表示されますが、よろしいですか？\n' +
        '※「バリューチェーン横断に切替」をオフにすれば、いつでも表示を切り替えられます。',
    filter:
        'クラスタ一覧で絞り込んだキーワード条件を解除しますか？\nバブルチャート上にテーマ内の全てのクラスタが表示されます。',
    changeClusterIdOfClusterList: '画面下部のクラスタ一覧で選択したクラスタも連動して変更されます。よろしいですか？',
    searchClusterList: 'キーワード検索を行うと、選択中のクラスタが解除されます。よろしいですか？',
    changeClusterIdOfLowerTab: '選択したバブルのクラスタで、画面下部の一覧情報を更新します。よろしいですか？'
}
